export const TRANSLATIONS_DE = {
  components: {
    header: { text: "Haben Sie Fragen?" },
    footer: {
      firstRow: "Cornèr Bank AG,",
      secondRow: "Via Canova 16, 6901 Lugano - Switzerland",
    },
  },
  screens: {
    common: {
      mr: "Herr",
      mrs: "Frau",
      haveQuestions: "Haben Sie Fragen?",
      back: "Zurück",
      continue: "Weiter",
      change: "Rückgeld",
      yes: "Ja",
      no: "Nein",
      none: "Keines",
      other: "Andere",
      confirm: "Bestätigen",
      remove: "Löschen",
      optional: "optional",
      skipStep: "Diesen Schritt überspringen",
      backHome: "Zur Website",
      cancelOnboarding: "Onboarding abbrechen ",
      search: "Suche",
      disclaimer: "Haftungsausschluss",
      impressum: "Impressum",
      copyrightAddr: "Tödistrasse 27, CH-8002, Zürich - Switzerland",
      errorDate: "Zugelassenes Alter 18 bis 65",
      underageBo: "Der/die wirtschaftlich Berechtigte muss volljährig sein.",
      chZipRequired: "Bitte geben Sie eine gültige Postleitzahl ein.",
      readOnlyMessage:
        "Fehlerhafte Angaben, die auf dieser Seite nicht geändert werden können, müssen Cornèrcard mitgeteilt werden.",
      disclaimerLink_prep:
        "https://www.prep.corner.ch/de/disclaimer/onboarding-corner3/index.html",
      disclaimerLink_prod:
        "https://www.corner.ch/de/disclaimer/onboarding-corner3/index.html",
    },
    personalData: {
      pageTitle: "Los geht’s!",
      pageSubtitle: "Eröffnen Sie Ihr Vorsorgekonto in nur wenigen Minuten.",
      firstName: "Vorname",
      lastName: "Nachname",
      dataInfo:
        "Geben Sie die Daten bitte genauso ein, wie sie auf Ihrem Ausweisdokument angegeben sind.",
      email: "E-Mail-Adresse",
      phoneNr: "Telefonnummer",
      emailRequired: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      phoneRequired:
        "Mobiltelefon (reine Zahlenangaben, keine Sonderzeichen, z. B.: 7812234567)",
      gtcAgree:
        "Ich bestätige, dass ich den <Disclaimer>Haftungsausschluss</Disclaimer> gelesen habe und diesen akzeptiere. Des Weiteren bestätige ich, dass ich die <Requirements>Voraussetzungen für die digitale Zeichnung des Produkts</Requirements> erfülle.",
      requirementsModal: {
        title: "Voraussetzungen für die digitale Zeichnung des Produkts",
        subTitle:
          "Die digitale Zeichnung des Produkts ist Personen vorbehalten, die:",
        data1:
          "in der Schweiz unbeschränkt steuerpflichtig sind und ein der AHV/IV unterstelltes Einkommen aus unselbstständiger oder selbstständiger Erwerbstätigkeit erzielen;",
        data2:
          "mit den Risiken im Zusammenhang mit der Nutzung von Computersystemen und/oder digitalen Kanälen wie beispielsweise Websites, Online-Plattformen oder Smartphone-Applikationen, die von der Cornèr Vorsorgestiftung Cornèr Dritte Säule, der Cornèr Bank AG und/oder Dritten zur Verfügung gestellt werden, vertraut sind und diese akzeptieren.",
        understood: "Ich habe verstanden",
      },
    },
    personalDataAdditional: {
      pageTitle: "Einige Informationen zu Ihrer Person",
      birthDate: "Geburtsdatum",
      birthCountry: "Geburtsland",
      nationality: "Nationalität",
      maritalStatus: "Zivilstand",
      maritalStatusList: {
        married: "Verheiratet oder eheähnlich",
        divorced: "Geschieden",
        widowed: "Verwitwet",
        unmarried: "Ledig",
        separated: "Getrennt",
      },
      avsNumber: "Ihre AHV-Nummer",
      avs: "Ihre AHV-Nummer",
      avsInfo: "<AvsInfo>Wo finde ich meine AHV-Nummer?</AvsInfo>",
      avsModal: {
        title: "Wo finde ich meine AHV-Nummer?",
        description:
          "Wenn Sie in der Schweiz wohnen oder arbeiten, finden Sie die AHV-Nummer auf der Vorderseite Ihrer Krankenversicherungskarte. Alternativ kann sie bei der Ausgleichskasse Ihres Wohnkantons angefragt werden.",
        understood: "Ich habe verstanden",
      },
    },
    address: {
      pageTitle: "Ihr Wohnsitz",
      pageSubTitle:
        "Die Zugangs-Codes zu den digitalen Bereichen Cornèronline und iCornèr App werden an die von Ihnen angegebene Adresse gesendet.",
      country: "Land",
      city: "Ort",
      zipCode: "PLZ",
      street: "Strasse",
      streetNumber: "Nummer",
    },
    employmentsDetail: {
      pageTitle:
        "In welcher beruflichen Stellung sind Sie derzeit beschäftigt?",
      employed: "Angestellt",
      freelancer: "Selbstständig",
      qualification: "Tätigkeit",
      pensionFund: "Sind Sie einer zweiten Säule angeschlossen?",
    },
    informationRecap: {
      pageTitle: "Überprüfen Sie Ihre Angaben!",
      pageSubtitle:
        "Bitte überprüfen Sie Ihre Angaben, bevor Sie den Vertrag unterschreiben.",
      cta: "Bestätigen",
      personalData: "Persönliche Daten und Kontaktinformationen",
      employmentsDetail: "Professionelle Informationen",
      terms:
        "Ich bestätige, dass ich die Informationen gelesen habe und die <Terms>Produktbedingungen</Terms> sowie die <GeneralTerms>Allgemeinen Geschäftsbedingungen der Bank</GeneralTerms> akzeptiere.",
      termsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_DE_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      termsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_DE_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      generalTermsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_DE_Condizioni-contrattuali.pdf",
      generalTermsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_DE_Condizioni-contrattuali.pdf",
      dataChanges:
        "Falls sich die Angaben im Laufe der Zeit ändern, sind Sie verpflichtet, die Bank unverzüglich schriftlich zu benachrichtigen.",
      gender: "Anrede:",
      firstName: "Vorname:",
      lastName: "Nachname:",
      email: "E-Mail-Adresse:",
      phoneNr: "Telefonnummer:",
      birthDate: "Geburtsdatum:",
      birthCountry: "Geburtsland:",
      nationality: "Nationalität:",
      maritalStatus: "Zivilstand:",
      city: "Ort:",
      zipCode: "PLZ:",
      street: "Strasse:",
      streetNumber: "Nummer:",
      avs: "Ihre AHV-Nummer:",
      currentPosition: "Beruflichen Stellung :",
      qualification: "Tätigkeit:",
      pensionFund: "Sind Sie einer zweiten Säule angeschlossen?",
    },
    contractView: {
      pageTitle: "Bereiten Sie sich auf die digitale Unterschrift vor!",
      pageSubtitle:
        "Bitte laden Sie Ihren Vertrag vor Beginn der digitalen Unterschrift herunter. Dieser ist auch während des Vorgangs der Video-Identifikation vollständig einsehbar.",
      downloadBtn: "Vertrag herunterladen",
      btnNext: "Weiter",
    },
    videoId: {
      pageTitle: "Unterschreiben Sie den Vertrag online",
      pageSubtitle:
        "Bereiten Sie die Kamera vor und halten<br/> Sie ein Ausweisdokument bereit.",
      mobileSubtitle:
        "Laden Sie die App für die Video-Identifizierung herunter und folgen Sie den Anweisungen.<br/><br/>Ihr Identifikationscode lautet:<br/> <b><TICKET></b>",
      singBtn: "Jetzt unterschreiben",
      asset:
        "Die digitale Unterschrift wird per Video-Identifikation mit einem Smartphone, Tablet oder Desktop von unserem Partner Intrum durchgeführt.",
    },
    videoIdUnavailable: {
      pageTitle: "Ups! <br/> Derzeit ist keine Bedienungsperson verfügbar",
      pageSubtitle:
        "Leider können wir Ihre Identität nicht bestätigen, da zu dieser Uhrzeit keine Bedienungsperson verfügbar ist. Wir haben Ihnen jedoch eine <b>E-Mail mit den verfügbaren Uhrzeiten sowie einen Link</b> geschickt, mit dem Sie Ihre Video-Identifizierung später wieder aufnehmen können. <br/><br/>Wir danken Ihnen für Ihr Verständnis!",
      backBtn: "Schliessen",
    },
    successVideoId: {
      pageTitle: "Perfekt!",
      pageSubtitle:
        "Ihre Identität wurde bestätigt.<br/> Wir werden Sie in den nächsten Tagen kontaktieren",
      backBtn: "Zur Webseite",
    },
    contract: {
      pageTitle: "Ihr Vertrag ist zur Unterzeichnung bereit",
      pageSubtitle:
        "Drucken Sie Ihren Vertrag aus und folgen Sie der Anleitung auf dem Deckblatt. Anschliessend senden Sie uns den unterzeichneten Vertrag und die erforderlichen Unterlagen per Post.",
      download: "Vertrag herunterladen",
      print: "Vertrag ausdrucken",
    },
    otpResume: {
      title: "Bestätigen Sie Ihre Identität",
      subtitle:
        "Geben Sie den sechsstelligen Code ein, den Sie per SMS erhalten haben",
      noSmsReveiced: "Haben Sie keinen Code erhalten? Kein Problem.",
      newSmsRequest: "<0>Beantragen Sie einen neuen Code<0>",
      otpExpired: "Your otp has expired: ask for a new one",
      otpInvalid: "Provided OTP is invalid",
      btnNext: "Weiter",
    },
    errors: {
      genericError: {
        title: "Es ist ein Fehler aufgetreten",
        subtitle:
          "Ups, etwas ist schiefgelaufen.<br/><br/>Bitte versuchen Sie es erneut.<br><br>",
        retry: "Erneut versuchen",
      },
      failureVideoId: {
        title: "Ups!<br/>Da ist etwas schiefgelaufen!",
        subtitle:
          "Leider war es nicht möglich, Ihre Identität zu bestätigen.<br/> Wir bitten Sie daher, den zuvor heruntergeladenen Vertrag auszudrucken und ordnungsgemäss unterschrieben an uns zu senden:<br/><br/><b>Vorsorgestiftung Cornèr Dritte Säule<br/>c/o Cornèr Bank AG<br/>Via Canova 16<br/>6901 Lugano<br/>Schweiz</b>",
      },
      underageNotAllowed: {
        title: "Die Bearbeitung Ihrer Anfrage ist leider nicht möglich",
        subtitle:
          "Dieses Produkt ist derzeit nur für volljährige Personen verfügbar. ",
      },
      chResidenceRequired: {
        title: "Die Bearbeitung Ihrer Anfrage ist leider nicht möglich",
        subtitle:
          "Dieses Produkt ist derzeit ausschliesslich in der Schweiz verfügbar. ",
      },
      taxResidenceMustBeCH: {
        title: "Die Bearbeitung Ihrer Anfrage ist leider nicht möglich",
        subtitle:
          "Dieses Produkt ist derzeit ausschliesslich in der Schweiz verfügbar. ",
      },
      exsclusiveOwnershipRequired: {
        title: "Die Bearbeitung Ihrer Anfrage ist leider nicht möglich",
        subtitle:
          "Für den Erwerb dieses Produktes müssen Sie die/der alleinige wirtschaftlich Berechtigte der Gelder sein.",
      },
      usNotAllowed: {
        title: "Die Bearbeitung Ihrer Anfrage ist leider nicht möglich",
        subtitle:
          "Dieses Produkt ist nicht für Personen verfügbar, welche die Definition einer «US Person» erfüllen",
      },
      missingData: {
        title: "Die Bearbeitung Ihrer Anfrage ist leider nicht möglich",
        subtitle:
          "Für die Bearbeitung Ihrer Anfrage fehlen leider noch einige Daten.<br/><br/>",
      },
    },
  },
  errors: {
    input: {
      invalidPattern: "Ungültiges Format",
      minLength: "Mindestens {{min}} Zeichen erforderlich",
      maxLength: "Maximal {{max}} Zeichen erlaubt",
      minPhoneLength:
        "Die Telefonnummer muss aus mindestens {{min}} Ziffern bestehen.",
      required: "Pflichtfeld",
      mismatch: "{{fieldName}} stimmt nicht überein",
      leadingZeroNotAllowed: "Die erste Ziffer darf nicht 0 sein",
    },
  },
  days: [
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
    "Sonntag",
  ],
  captchaDisclaimer:
    "Diese Website ist durch reCAPTCHA geschützt, es gelten<br/>die Google <0>Datenschutz-</0> und <1>Nutzungsbedingungen</1>.",
  captchaTooLow: {
    title: "Captcha-Überprüfung fehlgeschlagen",
    description: "Bitte versuche es erneut",
  },
};
